import { AppRouteProps } from "@harea/component";
import ProjectDayOffCreateContainer from "./container/ProjectDayOffCreateContainer";
import { ProjectAppointmentCreateVacationRoutes } from "views/create/views/vacation/ProjectAppointmentCreateVacationRoutes";
import { ProjectAppointmentCreateMissingRoutes } from "views/create/views/missing/ProjectAppointmentCreateMissingRoutes";
import ProjectTimeOffCreateLeavingContainer from "views/create/views/leaving/container/ProjectTimeOffCreateLeavingContainer";

export const ProjectDayOffCreateRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        element: <ProjectDayOffCreateContainer />,
        children: [
            // ...ProjectAppointmentCreateVacationRoutes,
            // ...ProjectAppointmentCreateMissingRoutes,
            {
                path: "",
                title: "BSMRH.Project.Appointment.Create.Label",
                element: <ProjectTimeOffCreateLeavingContainer />,
            }
        ]
    },
];
